import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { XCircle, Home } from "lucide-react";
import { Link } from "react-router-dom";
import { SEO } from "@/components/SEO";

const SurveyClosed = () => {
  return (
    <>
      <SEO 
        title="Survey Closed - SPO Member Consultation"
        description="The SPO Member Consultation on the Proposed Ware Crop Burn Down Compensation Scheme has now closed. Thank you to all members who participated."
        keywords={["SPO", "survey closed", "member consultation", "ware crop compensation"]}
      />
      <div className="min-h-screen bg-gradient-to-br from-background to-muted/30 py-12 pt-32">
        <div className="container mx-auto px-4 max-w-4xl">
          <Card className="shadow-xl">
            <CardHeader className="text-center space-y-6">
              <div className="flex justify-center">
                <XCircle className="h-16 w-16 text-muted-foreground" />
              </div>
              <CardTitle className="text-4xl font-bold text-primary">
                Survey Closed
              </CardTitle>
              <p className="text-xl text-muted-foreground">
                The SPO Member Consultation has now closed
              </p>
            </CardHeader>

            <CardContent className="space-y-8">
              <div className="bg-muted/50 rounded-lg p-8 text-center">
                <h2 className="text-2xl font-semibold text-primary mb-4">
                  SPO Member Consultation on the Proposed Ware Crop Burn Down Compensation Scheme
                </h2>
                <p className="text-lg text-muted-foreground mb-4">
                  Thank you to all members who participated in this important consultation. 
                  The survey has now closed and responses are no longer being accepted.
                </p>
                <p className="text-lg text-muted-foreground">
                  We appreciate your valuable input in helping shape the future of our compensation scheme.
                </p>
              </div>

              <div className="flex justify-center">
                <Button asChild size="lg">
                  <Link to="/" className="flex items-center gap-2">
                    <Home className="h-5 w-5" />
                    Return to Homepage
                  </Link>
                </Button>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </>
  );
};

export default SurveyClosed;